import {
  Tooltip,
  Typography,
  TypographyVariants,
  TypographyWeights,
  TypographyColors,
} from '@carboledger/ui';
import { Info } from '@carboledger/ui/icons';
import { cx } from '@/lib/utils';
import styles from './SummaryTile.module.scss';

/**
 * Props:
 *   label      the figure's caption
 *   value      the figure itself, already formatted
 *   info       tooltip text for an info icon after the label
 *   className  the row's own layout hook
 */
export const SummaryTile = ({ label, value, info, className }) => (
  <div className={cx(styles.tile, className)}>
    <span className={styles.bar} />
    <div className={styles.label}>
      <Typography variant={TypographyVariants.caption} color={TypographyColors.placeholder}>
        {label}
      </Typography>
      {info && (
        <Tooltip content={info} className={styles.info}>
          <Info size={16} aria-hidden="true" />
        </Tooltip>
      )}
    </div>
    <Typography
      variant={TypographyVariants.bodyLg}
      weight={TypographyWeights.semibold}
      color={TypographyColors.primary}
      className={styles.value}
    >
      {value}
    </Typography>
  </div>
);
